import { render } from "./RiderCard.vue?vue&type=template&id=9668d464"
import script from "./RiderCard.vue?vue&type=script&lang=js"
export * from "./RiderCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects 2022\\helmets-nepal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__